import { StatusBadge } from "@/components/ui";

import { runLabel, runStatusOf, runTone } from "../lib/runState";
import type { MountRecord } from "../types";

/** The badge for one added activity. The word comes from the one translation point. */
export function RunBadge({ mount }: { readonly mount: MountRecord | null }) {
  const status = runStatusOf(mount);
  return <StatusBadge tone={runTone(status)}>{runLabel(status)}</StatusBadge>;
}
